import { graphql } from "@/gql";

export const createWorkOrderJobOpeningMutation = graphql(`
  mutation CreateWorkOrderJobOpening($input: CreateWorkOrderJobOpeningInput!) {
    createWorkOrderJobOpening(input: $input) {
      id
      description
      depart_at
      deliver_at
      positions_available
      status
    }
  }
`);

export const updateWorkOrderJobOpeningMutation = graphql(`
  mutation UpdateWorkOrderJobOpening(
    $id: ID!
    $input: UpdateWorkOrderJobOpeningInput!
  ) {
    updateWorkOrderJobOpening(id: $id, input: $input) {
      id
      description
      depart_at
      deliver_at
      positions_available
      status
    }
  }
`);

export const sendJobOpeningOfferNotificationsMutation = graphql(`
  mutation SendJobOpeningOfferNotifications($id: ID!, $offerIds: [ID!]) {
    sendJobOpeningOfferNotifications(id: $id, offerIds: $offerIds)
  }
`);
